import { getKey, parseCwtEvc, parseJwtEvcUnverified, type Evc } from "@syadem/evc-js";

function isJwtToken(token: string): boolean {
  return token.split(".").length === 3;
}

export async function parseEvcToken(token: string): Promise<Evc> {
  if (isJwtToken(token)) {
    return parseJwtEvcUnverified(token).evc;
  }

  const result = await parseCwtEvc(token, getKey);
  return result.evc;
}
